import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Eyebrow, Reveal } from "./shared";

const FAQS = [
  {
    q: "What if it rains on Friday?",
    a: "Light rain, we grind — the machine doesn't mind. If the weather is genuinely bad, your job rolls to the following Friday and you get a text Thursday night. No re-booking, no phone tag.",
  },
  {
    q: "What about underground utility lines?",
    a: "Handled. Once your quote is locked, I call 811 on your behalf and utility crews come mark any underground lines — it's the law before grinding, it's free, and it takes up to 3 days. Lock in late in the week and marking may run past Thursday, which simply rolls your job to the following Friday. No re-booking, no phone tag.",
  },
  {
    q: "Do I need to be home?",
    a: "No. That's the whole point. Gate unlocked, stump accessible, and you can be at work, at brunch, anywhere. You'll get a photo when it's flat.",
  },
  {
    q: "How deep do you grind?",
    a: "Standard is 4–8 inches below grade — deep enough to reseed, lay sod, or plant over. Deeper grinds for landscaping beds can be quoted ahead of time.",
  },
  {
    q: "What happens to the wood chips?",
    a: "They stay in the hole as excellent free mulch — most people keep them. If you'd rather have them raked out and hauled, that's a small add-on on the quote.",
  },
  {
    q: "Will the machine fit through my gate?",
    a: "The grinder fits standard 36-inch backyard gates. Mention any tight squeezes in your notes or photo and I'll confirm before Friday — no surprises on the day.",
  },
  {
    q: "How do I pay?",
    a: "After you get the Friday photo proof, I text a simple payment link. No card upfront, no deposit, no invoice buried in your mailbox.",
  },
];

export default function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="mx-auto max-w-4xl scroll-mt-20 px-4 py-16 sm:px-8 sm:py-24">
      <Reveal>
        <Eyebrow>06 — Direct Answers</Eyebrow>
        <h2 className="mt-4 font-display text-2xl font-black uppercase leading-tight tracking-tight text-bone sm:text-3xl lg:text-4xl">
          Zero contractor fluff.
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <Accordion type="single" collapsible data-testid="faq-accordion" className="mt-10 border-t border-stone-800">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`item-${i}`} className="border-stone-800">
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="py-5 font-display text-lg font-bold uppercase tracking-normal text-bone hover:text-amber-500 hover:no-underline sm:text-xl"
              >
                <span className="mr-4 font-mono text-xs text-amber-500/70">{String(i + 1).padStart(2, "0")}</span>
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 pl-10 text-sm leading-relaxed text-stone-400 sm:text-base">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </section>
  );
}
